import axios from "axios";

export function logout({ clearDefaults = false, navigate }) {
  // always clear auth + derived UI bits
  const baseKeys = [
    "accessToken",
    "tokenType",
    "refreshToken",
    "userType",
    "userGuid",
    "subscriptionPlanGuid",
    "firstLetter",
    "selectedBoardGuid",
    "selectedQualificationGuid",
    "hasCompletedOnboarding",      // legacy flag
  ];

  // clearDefaults=true => also clear versioned onboarding + default home
  const defaultKeys = [
    "hasCompletedOnboardingVersion",
    "defaultHomeUrl",
  ];

  const keys = clearDefaults ? [...baseKeys, ...defaultKeys] : baseKeys;
  keys.forEach(k => localStorage.removeItem(k));

  // session-only stuff (e.g., payment flow)
  sessionStorage.removeItem("selectedPlan");

  // optional: remove any global axios auth header
  try { delete axios.defaults.headers.common.Authorization; } catch {}

  // go to login (replace so back button won't re-enter the app)
  navigate("/login", { replace: true });
}
